
import { Component, AfterViewInit, OnInit, Output, EventEmitter, Input } from '@angular/core';
import { PaymentsService } from 'src/app/services/core/payments/payments.service';
;
import { sweetAlert } from 'src/app/utils/swal';
import { urls } from 'src/app/utils/url.utils';
@Component({
  selector: 'app-payment-card-modal',
  templateUrl: './payment-card-modal.component.html'
})
export class PaymentCardModalComponent implements AfterViewInit {
  @Input() member: any;
  @Output() close = new EventEmitter<any>();

  payments: any;
  card: any;

  constructor(
    private paymentService:PaymentsService
  ){

  }
  closeModal() {
    this.close.emit();
  }
  async ngAfterViewInit() {

    await this.loadSquareScript();

    const Square = (window as any).Square;

    this.payments = await Square.payments(
      urls.SQUARE_APPICATION_ID,
      urls.SQUARE_LOCATION_ID
    );
    this.card = await this.payments.card();

    await this.card.attach('#card-container');
  }

  async pay() {
    const result = await this.card.tokenize();
    if (result.status === 'OK') {
      const payload = {
        source: result.token,
        member: this.member?.id,
        cardholderName:this.member?.displayName,
        billingAddress: this.member?.address

      }
      this.paymentService.addCard(payload).subscribe({
            next: (response: any) => {
            this.close.emit({success:true});
            },
            error: () => {
              sweetAlert('Error', 'Failed to add payment method', 'error', 'Ok');
            },
          });

    } else {
      console.error(result.errors);
    }
  }



  private loadSquareScript(): Promise<void> {
    return new Promise((resolve, reject) => {
      if ((window as any).Square) {
        resolve();
        return;
      }

      const script = document.createElement('script');
      script.src = urls.SQUARE_DEVELOPER_URL;
      script.onload = () => resolve();
      script.onerror = () => reject('Square SDK failed to load');
      document.body.appendChild(script);
    });
  }
}